export const topicsData = [
  { id: 1, name: '科幻巨制', icon: 'ri-rocket-2-line', heat: '128.6万讨论', tag: '热门' },
  { id: 2, name: '悬疑剧场', icon: 'ri-search-eye-line', heat: '96.3万讨论', tag: '新番' },
  { id: 3, name: '古装大戏', icon: 'ri-ancient-gate-line', heat: '87.1万讨论', tag: '热播' },
  { id: 4, name: '动作大片', icon: 'ri-fire-line', heat: '74.5万讨论', tag: '' },
  { id: 5, name: '喜剧专区', icon: 'ri-emotion-laugh-line', heat: '68.2万讨论', tag: '推荐' },
  { id: 6, name: '动漫精选', icon: 'ri-movie-2-line', heat: '59.8万讨论', tag: '' },
  { id: 7, name: '纪录片库', icon: 'ri-earth-line', heat: '52.4万讨论', tag: '精品' },
  { id: 8, name: '韩剧热播', icon: 'ri-heart-line', heat: '45.9万讨论', tag: '飙升' },
  { id: 9, name: '国产剧集', icon: 'ri-flag-2-line', heat: '41.3万讨论', tag: '' },
];

export const cardsData = [
  {
    id: 1,
    title: '《星际迷航：新纪元》蓝光独家上线',
    desc: '视觉特效全面升级，4K HDR 画质带来沉浸式宇宙冒险体验，零缓冲流畅播放。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20battle%20scene%20with%20starships%20and%20nebulae%2C%20cinematic%20lighting%20with%20deep%20blues%20and%20golden%20explosions%2C%20professional%20movie%20poster%20aesthetic%2C%20dramatic%20composition%2C%20high%20contrast%2C%204K%20quality%20feel&width=800&height=500&seq=card-movie-01&orientation=landscape',
    tags: ['科幻', '蓝光'],
    date: '2026-07-30',
  },
  {
    id: 2,
    title: '《迷雾追踪》第三季全网首播',
    desc: '烧脑悬疑再升级，层层反转令人窒息，超清画质让每一个细节都清晰可见。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20urban%20street%20at%20night%20with%20detective%20silhouette%2C%20noir%20film%20aesthetic%2C%20warm%20street%20lamp%20glow%20against%20dark%20surroundings%2C%20cinematic%20thriller%20atmosphere%2C%20professional%20photography%20style&width=800&height=500&seq=card-movie-02&orientation=landscape',
    tags: ['悬疑', '首播'],
    date: '2026-07-29',
  },
  {
    id: 3,
    title: '《长安风云录》古装权谋大剧热播中',
    desc: '盛唐背景下权谋与情义的巅峰对决，服化道精良，蓝光画质还原盛世风华。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20ornate%20golden%20decorations%20and%20flowing%20silk%20curtains%2C%20warm%20candlelight%20ambiance%2C%20historical%20costume%20drama%20aesthetic%2C%20rich%20red%20and%20gold%20tones%2C%20cinematic%20composition&width=800&height=500&seq=card-movie-03&orientation=landscape',
    tags: ['古装', '热播'],
    date: '2026-07-28',
  },
  {
    id: 4,
    title: '《极速追击》硬核动作爽片不容错过',
    desc: '全程高能无尿点，飙车枪战拳拳到肉，超清播放每一帧都是桌面壁纸级别。',
    image: 'https://readdy.ai/api/search-image?query=Intense%20car%20chase%20through%20neon-lit%20city%20streets%20at%20night%2C%20action%20movie%20aesthetic%2C%20motion%20blur%20effect%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20cool%20shadows%2C%20cinematic%20photography&width=800&height=500&seq=card-movie-04&orientation=landscape',
    tags: ['动作', '爽片'],
    date: '2026-07-27',
  },
  {
    id: 5,
    title: '《欢乐一家人》第五季爆笑回归',
    desc: '温馨家庭喜剧再掀笑浪，适合全家一起观看，轻松解压最佳选择。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20living%20room%20scene%20with%20soft%20natural%20lighting%2C%20cozy%20modern%20home%20interior%2C%20bright%20and%20cheerful%20atmosphere%2C%20sitcom%20style%20photography%2C%20comfortable%20sofa%20and%20warm%20color%20palette&width=800&height=500&seq=card-movie-05&orientation=landscape',
    tags: ['喜剧', '回归'],
    date: '2026-07-26',
  },
  {
    id: 6,
    title: '《深海异兽》科幻惊悚新片速递',
    desc: '深海未知生物与人类的惊心遭遇，震撼音效配合超清画面，恐怖氛围拉满。',
    image: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20mysterious%20bioluminescent%20creatures%2C%20dark%20blue%20abyss%20with%20dramatic%20light%20rays%20penetrating%20water%2C%20thriller%20movie%20aesthetic%2C%20cinematic%20underwater%20photography%2C%20eerie%20atmosphere&width=800&height=500&seq=card-movie-06&orientation=landscape',
    tags: ['科幻', '新片'],
    date: '2026-07-25',
  },
  {
    id: 7,
    title: '《山河岁月》大型历史纪录片上线',
    desc: '跨越五千年的华夏文明之旅，4K修复珍贵史料首次公开，不可错过的视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20landscape%20with%20ancient%20temples%20on%20misty%20mountains%2C%20golden%20sunrise%20light%2C%20documentary%20cinematography%20style%2C%20vast%20natural%20scenery%2C%20warm%20earthy%20tones%2C%20grand%20scale%20composition&width=800&height=500&seq=card-movie-07&orientation=landscape',
    tags: ['纪录', '精品'],
    date: '2026-07-24',
  },
];

export const indexData = [
  { id: 1, title: '蓝光电影专区', count: '2,386部', icon: 'ri-film-line', desc: '杜比全景声原盘压制' },
  { id: 2, title: '热门电视剧场', count: '5,720集', icon: 'ri-tv-2-line', desc: '日更热剧追不停' },
  { id: 3, title: '动漫番剧库', count: '1,845部', icon: 'ri-ghost-smile-line', desc: '新番同步更新中' },
  { id: 4, title: '综艺娱乐汇', count: '3,120期', icon: 'ri-live-line', desc: '热门综艺一网打尽' },
  { id: 5, title: '纪录片频道', count: '968部', icon: 'ri-global-line', desc: 'BBC NHK 精选' },
  { id: 6, title: '动作冒险集', count: '1,432部', icon: 'ri-shield-flash-line', desc: '肾上腺素飙升' },
  { id: 7, title: '悬疑烧脑馆', count: '876部', icon: 'ri-lightbulb-flash-line', desc: '反转结局猜不透' },
];

export const rankingData = [
  { id: 1, rank: 1, title: '长安风云录', category: '古装权谋', score: '9.6', heat: '本周飙升第1名', trend: 'up' },
  { id: 2, rank: 2, title: '星际迷航：新纪元', category: '科幻冒险', score: '9.5', heat: '新片热度爆表', trend: 'up' },
  { id: 3, rank: 3, title: '迷雾追踪 第三季', category: '悬疑推理', score: '9.4', heat: '口碑持续走高', trend: 'up' },
  { id: 4, rank: 4, title: '极速追击', category: '动作犯罪', score: '9.3', heat: '票房口碑双丰收', trend: 'up' },
  { id: 5, rank: 5, title: '欢乐一家人 第五季', category: '家庭喜剧', score: '9.2', heat: '回归即霸榜', trend: 'new' },
  { id: 6, rank: 6, title: '深海异兽', category: '科幻惊悚', score: '9.1', heat: '新片强势上榜', trend: 'new' },
  { id: 7, rank: 7, title: '山河岁月', category: '历史纪录', score: '9.0', heat: '好评如潮', trend: 'stable' },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '蓝光画质',
    desc: '全站资源采用 H.265 编码压制，支持 4K 超清与蓝光原盘画质，P2P CDN 加速确保零缓冲播放体验，每一帧都是视觉享受。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速不卡顿',
    desc: '全球多节点 CDN 智能调度，自适应码率技术根据网络环境自动调整清晰度，看片从此告别加载圈圈与卡顿困扰。',
  },
  {
    id: 3,
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '收录超过五万部电影与电视剧集，涵盖动作、科幻、悬疑、古装、喜剧、动漫等全品类，每日更新实时同步最新资源。',
  },
];

export const appData = {
  title: '移动观影新体验',
  desc: '下载 91免费在线视频 手机客户端，随时随地畅享蓝光画质。支持离线缓存、投屏播放、倍速调节，地铁上也能流畅追剧。',
  features: ['离线缓存随时看', '一键投屏大屏观影', '智能续播记忆进度', '夜间模式护眼舒适'],
  image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%20with%20film%20posters%2C%20dark%20theme%20UI%2C%20clean%20minimal%20design%2C%20floating%20phone%20on%20warm%20gradient%20background%2C%20professional%20product%20photography%2C%20soft%20lighting&width=600&height=800&seq=app-mockup-01&orientation=portrait',
};

export const carouselData = [
  {
    id: 1,
    title: '暑期档必看大片合集',
    desc: '精选暑期最值得观看的十部电影，从视觉奇观到深度剧情，承包你的整个夏天。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20collage%20with%20warm%20golden%20sunset%20light%2C%20film%20reel%20and%20popcorn%20aesthetic%2C%20vintage%20cinema%20atmosphere%2C%20dramatic%20lighting%2C%20rich%20amber%20and%20coral%20tones&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '合集推荐',
  },
  {
    id: 2,
    title: '华语佳片三十年精选',
    desc: '从经典到新锐，盘点华语电影三十年来的里程碑之作，每一部都值得反复回味。',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20cinema%20aesthetic%20with%20film%20strip%20and%20vintage%20movie%20posters%2C%20warm%20sepia%20tone%20lighting%2C%20nostalgic%20atmosphere%2C%20artistic%20composition%2C%20golden%20age%20of%20film%20vibe&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '经典回顾',
  },
  {
    id: 3,
    title: '韩剧迷不可错过的口碑剧',
    desc: '高分韩剧一网打尽，从浪漫爱情到悬疑烧脑，每一部都是精心挑选的口碑佳作。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20aesthetic%20with%20soft%20romantic%20lighting%2C%20cherry%20blossom%20and%20urban%20night%20scene%2C%20warm%20pink%20and%20golden%20tones%2C%20cinematic%20composition%2C%20elegant%20and%20emotional%20atmosphere&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '韩剧精选',
  },
  {
    id: 4,
    title: '科幻迷的终极片单',
    desc: '从硬核科幻到太空歌剧，收录了改变科幻电影史的重量级作品，想象力没有边界。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20with%20flying%20vehicles%20and%20neon%20lights%2C%20cyberpunk%20aesthetic%2C%20dramatic%20contrast%20between%20warm%20neon%20and%20dark%20skies%2C%20cinematic%20scale%2C%20epic%20composition&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '科幻殿堂',
  },
  {
    id: 5,
    title: '纪录片里的真实世界',
    desc: '精选BBC、NHK等顶级制作，用镜头探索自然、历史与人文的无限魅力。',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20African%20savanna%20with%20wildlife%20at%20golden%20hour%2C%20documentary%20cinematography%2C%20warm%20earthy%20tones%2C%20vast%20landscape%2C%20professional%20nature%20photography&width=800&height=450&seq=carousel-05&orientation=landscape',
    tag: '纪录之窗',
  },
  {
    id: 6,
    title: '国漫崛起·精品动画特辑',
    desc: '见证国漫从崛起到辉煌，精选近年来画面与故事俱佳的国产动画电影与番剧。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20ink%20wash%20painting%20aesthetic%2C%20mythical%20creatures%20in%20misty%20mountains%2C%20ethereal%20lighting%2C%20traditional%20Chinese%20art%20meets%20modern%20animation%2C%20poetic%20atmosphere&width=800&height=450&seq=carousel-06&orientation=landscape',
    tag: '国漫之光',
  },
];

export const commentsData = [
  {
    id: 1,
    name: '影迷小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%2C%20warm%20smile%2C%20clean%20studio%20lighting%2C%20simple%20neutral%20background%2C%20professional%20yet%20friendly%20look&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '用了大半年了，画质真的没话说，蓝光资源更新速度也很快。追《长安风云录》的时候一点都不卡，比之前用的几个站都稳定。',
    time: '2小时前',
    rating: 5,
  },
  {
    id: 2,
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%2C%20friendly%20expression%2C%20clean%20studio%20lighting%2C%20simple%20neutral%20background%2C%20professional%20look&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '韩剧更新速度简直神了！隔壁还在等字幕组的时候这里已经可以看了，而且全是超清画质，投屏到电视上看效果特别好。',
    time: '5小时前',
    rating: 5,
  },
  {
    id: 3,
    name: '电影控老张',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle-aged%20Chinese%20man%2C%20mature%20and%20confident%2C%20clean%20studio%20lighting%2C%20simple%20neutral%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '老影迷了，纪录片库的资源很全，BBC的《山河岁月》在这里找到了完整版，画质比以前下载的720p好太多了。',
    time: '1天前',
    rating: 5,
  },
  {
    id: 4,
    name: '动漫控阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20teenage%20Chinese%20boy%2C%20casual%20and%20friendly%2C%20clean%20studio%20lighting%2C%20simple%20neutral%20background&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '国漫专区太赞了！好多新番同步更新，而且有弹幕功能，和小伙伴们一起看番特别有意思。希望片库越来越丰富！',
    time: '2天前',
    rating: 4,
  },
];

export const faqData = [
  {
    id: 1,
    question: '91免费在线视频是否需要注册才能观看？',
    answer: '不需要注册即可观看绝大部分内容。我们致力于提供零门槛的高清观影体验，打开网站即可开始观看。部分独家蓝光资源可能需要简单验证后播放，但不会强制要求注册账号。',
  },
  {
    id: 2,
    question: '视频加载慢或卡顿怎么办？',
    answer: '我们采用了全球多节点CDN加速与P2P传输技术，正常情况下播放流畅不卡顿。如果遇到卡顿，建议检查本地网络状况，或尝试切换清晰度。系统会根据您的网速自动调整码率，确保最佳播放体验。',
  },
  {
    id: 3,
    question: '支持哪些设备观看？',
    answer: '支持电脑、平板、手机等所有主流设备。PC端直接访问网站即可观看，移动端可以使用手机浏览器访问或下载我们的移动客户端，体验更佳。同时支持投屏到智能电视大屏观影。',
  },
  {
    id: 4,
    question: '视频资源更新频率如何？',
    answer: '电影和电视剧资源每日实时更新，热门剧集通常在播出后2小时内即可上线。动漫新番每周同步更新，综艺节目次日更新。我们拥有专业的内容团队，确保您在第一时间看到最新内容。',
  },
  {
    id: 5,
    question: '是否有广告？观影安全吗？',
    answer: '我们承诺全程无弹窗广告、无强制插播广告，为观众提供纯净的观影环境。网站采用HTTPS加密传输，不收集用户隐私信息，请放心使用。如果遇到任何问题，欢迎通过联系我们页面反馈。',
  },
];

export const aboutData = {
  title: '关于91免费在线视频',
  desc1: '91免费在线视频是一个专注于提供高品质免费影视内容的在线平台。我们致力于为全球华语观众打造一个零缓冲、高清画质的观影空间，让每一个人都能轻松享受影视带来的快乐。',
  desc2: '平台收录超过五万部电影、电视剧、动漫、纪录片和综艺节目，覆盖动作、科幻、悬疑、古装、喜剧等全品类内容。所有资源均采用H.265高效编码，支持4K超清与蓝光画质播放。',
  desc3: '我们拥有一支专业的内容运营团队，每日实时追踪全球最新影视资源，确保观众在第一时间观看到最新内容。同时，我们持续优化播放技术与用户体验，让91免费在线视频成为您最值得信赖的在线观影伙伴。',
};

export const mediaData = [
  {
    id: 1,
    title: '长安风云录 第28集',
    duration: '45:32',
    category: '古装权谋',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20court%20scene%20with%20elaborate%20costumes%20and%20candlelit%20atmosphere%2C%20dramatic%20historical%20drama%20cinematography%2C%20warm%20golden%20interior%20lighting%2C%20rich%20textures%20of%20silk%20and%20wood&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '星际迷航：新纪元 正片',
    duration: '2:18:45',
    category: '科幻冒险',
    image: 'https://readdy.ai/api/search-image?query=Space%20exploration%20scene%20with%20futuristic%20starship%20approaching%20a%20glowing%20nebula%2C%20cinematic%20sci-fi%20aesthetic%2C%20deep%20space%20with%20star%20clusters%2C%20heroic%20composition%2C%20epic%20scale&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '迷雾追踪 第三季 第6集',
    duration: '52:18',
    category: '悬疑推理',
    image: 'https://readdy.ai/api/search-image?query=Dark%20rainy%20alley%20at%20night%20with%20a%20single%20figure%20under%20street%20lamp%2C%20film%20noir%20aesthetic%2C%20moody%20atmosphere%20with%20deep%20shadows%2C%20mysterious%20and%20suspenseful%20cinematography&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '欢乐一家人 第五季 第3集',
    duration: '38:20',
    category: '家庭喜剧',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cozy%20modern%20kitchen%20with%20family%20gathering%2C%20warm%20natural%20sunlight%20through%20windows%2C%20cheerful%20sitcom%20aesthetic%2C%20colorful%20and%20lively%20atmosphere%2C%20professional%20TV%20show%20lighting&width=640&height=360&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: '山河岁月 第4集：大秦帝国',
    duration: '58:45',
    category: '历史纪录',
    image: 'https://readdy.ai/api/search-image?query=Terracotta%20warriors%20in%20dramatic%20side%20lighting%2C%20ancient%20Chinese%20historical%20artifacts%2C%20warm%20earthy%20tones%2C%20documentary%20cinematography%20style%2C%20majestic%20and%20timeless%20composition&width=640&height=360&seq=media-05&orientation=landscape',
  },
];

export const updatesData = [
  {
    id: 1,
    date: '2026-07-31',
    title: '《长安风云录》大结局提前点映',
    content: '应广大观众强烈要求，《长安风云录》大结局将于今晚20:00提前上线，蓝光版同步更新。',
    tag: '重磅',
  },
  {
    id: 2,
    date: '2026-07-30',
    title: '纪录片专区全新改版上线',
    content: '纪录片频道完成全面改版，新增分类筛选与专题合集功能，浏览体验大幅提升。',
    tag: '更新',
  },
  {
    id: 3,
    date: '2026-07-29',
    title: '暑期档海外大片集中引进',
    content: '本月已引进12部海外院线大片，涵盖动作、科幻、动画等多种类型，蓝光画质陆续上线。',
    tag: '上新',
  },
  {
    id: 4,
    date: '2026-07-28',
    title: '移动端播放器全面升级',
    content: '移动客户端播放器升级至V3.0版本，新增手势控制亮度音量、AI智能字幕等实用功能。',
    tag: '升级',
  },
  {
    id: 5,
    date: '2026-07-27',
    title: 'P2P加速节点新增日韩线路',
    content: '为提升海外用户观影体验，新增日本与韩国P2P加速节点，亚太地区加载速度提升40%。',
    tag: '优化',
  },
  {
    id: 6,
    date: '2026-07-26',
    title: '国漫《星辰变》第六季独家上线',
    content: '人气国漫《星辰变》第六季在91免费在线视频独家首播，每周五更新两集。',
    tag: '独家',
  },
  {
    id: 7,
    date: '2026-07-25',
    title: '用户投稿通道正式开放',
    content: '即日起开放用户内容投稿通道，优质影视推荐与影评将有机会在首页展示，欢迎各位影迷踊跃参与。',
    tag: '公告',
  },
];

export const contactData = {
  title: '联系我们',
  desc: '如果您有影片推荐、内容反馈、合作洽谈等需求，欢迎通过以下方式与我们取得联系。我们珍视每一位观众的声音。',
  email: 'feedback@91freevideo.com',
  qq: '1234567890',
  wechat: '91freevideo',
  tips: '投稿时请注明影片名称、类型及推荐理由，优质内容将优先审核上线。',
};